import { Injectable } from '@angular/core';
import {BaseService} from './base.service';
import { EmailModel } from '../model/email.model';

@Injectable()
export class EmailService {

  path = '/email';

  constructor(private baseService: BaseService) { }
  
  getPaginated(init: number, end: number, address: string, user: string) {
    return this.baseService.get(this.path, '', { init, end, address, user});
  }

  getAll() {
    return this.baseService.get(this.path, '');
  }

  findByChecklistId(checklistId: number) {
    return this.baseService.get(this.path, '/by-checklist/' + checklistId);
  }

  post(email: EmailModel) {
    return this.baseService.post(this.path, '/', email);
  }

  put(email: EmailModel) {
    return this.baseService.put(this.path, '/', email);
  }

  save(email: EmailModel) {
    if (email.id) {
      return this.put(email);
    } else {
      return this.post(email);
    }
  }

  saveEmailsInChecklist(emails: any[], checklist_id) {
    return this.baseService.post(this.path, '/in-checklist/' + checklist_id, emails);
  }

  delete(idEmail: number){
    return this.baseService.delete(this.path, '/' + idEmail);
  }
  getByUserId(id) {
    return this.baseService.get(this.path, `/user/${id}`);
  }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/service/email.service.ts